<p>noticie-email-details works!</p>
